import React from 'react';
import { FiStar } from 'react-icons/fi';
import './StarRating.css';

const StarRating = ({
  value = 0,
  onChange,
  max = 5,
  size = 'medium',
  readonly = false,
  label
}) => {
  const handleClick = (rating) => {
    if (!readonly && onChange) {
      onChange(rating);
    }
  };

  return (
    <div className={`star-rating star-rating-${size}`}>
      {label && <span className="rating-label">{label}</span>}
      <div className="stars">
        {[...Array(max)].map((_, index) => {
          const rating = index + 1;
          return (
            <button
              key={index}
              type="button"
              className={`star ${rating <= value ? 'filled' : ''}`}
              onClick={() => handleClick(rating)}
              disabled={readonly}
            >
              <FiStar />
            </button>
          );
        })}
      </div>
      {value > 0 && <span className="rating-value">{value}/{max}</span>}
    </div>
  );
};

export default StarRating;
